import React, { useState, useEffect } from "react";
import { AgCharts } from "ag-charts-react";
import { PieTypeDataModel } from "../../model/DashbroadModel";

const Chart = ({ data }: { data: PieTypeDataModel[] }) => {
  const [chartData, setChartData] = useState<PieTypeDataModel[]>(data);
  const [options, setOptions] = useState<any>({
    title: {
      text: "",
    },
    subtitle: {
      text: "",
    },
    data: chartData,
    series: [
      {
        type: "line",
        xKey: "x",
        yKey: "y",
        yName: "Ngày tạo",
      },
    ],
  });

  useEffect(() => {
    setChartData(data);
    setOptions((prevOptions: any) => ({
      ...prevOptions,
      data: data,
    }));
  }, [data]);

  return <AgCharts options={options} />;
};

export default Chart;
